import { render, staticRenderFns } from "./ArticleContent.vue?vue&type=template&id=4eebe56e&scoped=true&"
import script from "./ArticleContent.vue?vue&type=script&lang=js&"
export * from "./ArticleContent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContent.vue?vue&type=style&index=0&id=4eebe56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eebe56e",
  null
  
)

export default component.exports